import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, LinkData, TextInput } from '../../types'
import {
  CmsConverterService, defaultFSCatalog, defaultLinkData, defaultTextInput
} from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBoxesMediaConverter extends CmsConverterService<TeaserBoxesMediaData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      headline: formData.st_headline ?? defaultTextInput,
      items: formData.st_teaser_boxes ?? defaultFSCatalog,
      zoomOut: formData.st_zoom_out?.value || false,
      link: formData.st_link ?? defaultLinkData
    }
  }
}

export const TEASER_BOXES_MEDIA_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxesMediaData>>('TeaserBoxesMediaConverter')

export interface TeaserBoxesMediaData extends ConvertedComponentData {
  items: FsCatalog;
  backgroundColor: string;
  headline: TextInput;
  zoomOut: boolean;
  link: LinkData;
}
